import { Route, Routes } from "react-router-dom";
import Home from "../pages/home/Home";
import Shop from "../pages/shop/Shop";
import Contact from "../pages/contact/Contact";
import Company from "../pages/about/company/Company";
import Community from "../pages/about/community/Community";
import Gallery from "../pages/about/gallery/Gallery";
import ProductServices from "../pages/about/products-serv/ProductServices";
import Error from "../shared/error/Error";
import Policy from "../shared/compliance/Policy/Policy";
import TermsOfService from "../shared/compliance/TermsOfService/TermsOfService";

function Routers() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about">
        <Route path="" element={<Company />} />
        <Route path="company" element={<Company />} />
        <Route path="community" element={<Community />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="products-services" element={<ProductServices />} />
        <Route path="*" element={<Error />} />
      </Route>
      <Route path="/policy" element={<Policy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="*" element={<Error />} />
    </Routes>
  );
}

export default Routers;
